/**
 * Demo mode = the real console running on an in-browser fixture world (Mock
 * Service Worker intercepts every rhino-api call; no backend, no Cognito).
 *
 * It is a BUILD-TIME switch only: `VITE_DEMO=1` (`npm run demo`,
 * `npm run build:demo`, the per-PR preview workflow). Vite inlines the value,
 * so a production build contains no demo code path and no runtime flag can
 * turn mocking on against real users.
 */
export function readDemoFlag(viteFlag: string | boolean | undefined): boolean {
  return viteFlag === '1' || viteFlag === 'true' || viteFlag === true;
}

export const DEMO_MODE: boolean = readDemoFlag(import.meta.env.VITE_DEMO);

export function isDemo(): boolean {
  return DEMO_MODE;
}

/** Signed-in ops user shown in demo mode (fictional). */
export const DEMO_EMAIL = 'demo.ops@dnmlogistics.in';
